module.exports = __webpack_public_path__ + "img/distrisam.9a20bd3e.jpeg";